var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wordhomw-wrap"},[_c('div',{staticClass:"v-note-wrapper markdown-body shadow",attrs:{"data-v-7a63e4b3":""}},[_c('h1',[_c('a',{attrs:{"id":"_0"}}),_vm._v("多租户相关")]),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("多租户配置")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("租户共享数据配置")])])])])])
}]

export { render, staticRenderFns }